import {
  CREATING_USER_REQUEST,
  CREATING_USER_REQUEST_SUCCEEDED,
  CREATING_USER_REQUEST_FAILED,
  FETCHING_USER,
  FETCHING_USER_SUCCEEDED,
  FETCHING_USER_FAILED,
  FETCHING_USERS,
  FETCHING_USERS_SUCCEEDED,
  FETCHING_USERS_FAILED,
  UPDATING_USER_REQUEST,
  UPDATING_USER_SUCCEEDED,
  UPDATING_USER_FAILED,
  UPDATING_USER_PERMISSIONS,
  UPDATING_USER_PERMISSIONS_SUCCEEDED,
  UPDATING_USER_PERMISSIONS_FAILED,
  ACTIVATING_USER_REQUEST,
  ACTIVATING_USER_SUCCEEDED,
  ACTIVATING_USER_FAILED,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCEEDED,
  RESET_PASSWORD_FAILED,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST_SUCCEEDED,
  RESET_PASSWORD_REQUEST_FAILED,
  RESET_PASSWORD_LINK,
  RESET_PASSWORD_LINK_SUCCEEDED,
  RESET_PASSWORD_LINK_FAILED,
  DELETING_USER_REQUEST,
  DELETING_USER_SUCCEEDED,
  DELETING_USER_FAILED,
  FETCHING_COGNITO_USER_PROFILE,
  FETCHING_COGNITO_USER_PROFILE_SUCCEEDED,
  FETCHING_COGNITO_USER_PROFILE_FAILED,
  FETCHING_USERS_COUNT,
  FETCHING_USERS_COUNT_SUCCEEDED,
  FETCHING_USERS_COUNT_FAILED,
  FETCHING_ACTIVE_USERS_COUNT,
  FETCHING_ACTIVE_USERS_COUNT_SUCCEEDED,
  FETCHING_ACTIVE_USERS_COUNT_FAILED,
  FETCHING_DAU_COUNT,
  FETCHING_DAU_COUNT_SUCCEEDED,
  FETCHING_DAU_COUNT_FAILED,
  FETCHING_WAU_COUNT,
  FETCHING_WAU_COUNT_SUCCEEDED,
  FETCHING_WAU_COUNT_FAILED,
  FETCHING_MAU_COUNT,
  FETCHING_MAU_COUNT_SUCCEEDED,
  FETCHING_MAU_COUNT_FAILED,
  FETCHING_NEW_USERS_COUNT,
  FETCHING_NEW_USERS_COUNT_SUCCEEDED,
  FETCHING_NEW_USERS_COUNT_FAILED,
  FETCHING_DEACTIVATED_USERS_COUNT,
  FETCHING_DEACTIVATED_USERS_COUNT_SUCCEEDED,
  FETCHING_DEACTIVATED_USERS_COUNT_FAILED,
  FETCHING_COLLECTIONS,
  FETCHING_COLLECTIONS_SUCCEEDED,
  FETCHING_COLLECTIONS_FAILED

} from "constants/actionTypes";

const initState = {
  me: null,
  authenticating: false,
  authenticated: true,
  authenticationError: null,
  loading: false,
  items: [],
  count: {
    all: {
      fetching: false,
      error: null,
      total: 0,
    },
    active: {
      fetching: false,
      error: null,
      total: 0,
    },
    deactivated: {
      fetching: false,
      error: null,
      total: 0,
    },
    new: {
      fetching: false,
      error: null,
      total: 0,
    },
    dau: {
      fetching: false,
      error: null,
      total: 0,
    },
    wau: {
      fetching: false,
      error: null,
      total: 0,
    },
    mau: { fetching: false, error: null, total: 0 },
  },
  collections: {
    loading: false,
    items: [],
    pagination: {
      currentPage: -1,
      totalPages: 1,
      recordsPerPage: 20,
      totalRecordsCount: 0,
    },
  },
  pagination: {
    currentPage: -1,
    totalPages: 1,
    recordsPerPage: 20,
    totalRecordsCount: 0,
  },
  user: null,
  creatingUser: {
    creating: false,
    success: false,
    error: null,
  },
  fetchingUser: {
    fetching: false,
    success: false,
    error: null,
  },
  fetchingDailyActiveUsers: {
    count: 0,
    fetching: false,
    success: false,
    error: null,
  },
  fetchingWeeklyActiveUsers: {
    count: 0,
    fetching: false,
    success: false,
    error: null,
  },
  fetchingMonthlyActiveUsers: {
    count: 0,
    fetching: false,
    success: false,
    error: null,
  },
  fetchingNewUsers: {
    count: 0,
    fetching: false,
    success: false,
    error: null,
  },
  fetchingDeactivatedUsers: {
    count: 0,
    fetching: false,
    success: false,
    error: null,
  },
  updatingUser: {
    updating: false,
    success: false,
    error: null,
  },
  activatingUser: {
    activating: false,
    success: false,
    error: null,
  },
  resettingPassword: {
    resetting: false,
    success: false,
    error: null,
  },
  resettingPasswordRequest: {
    requesting: false,
    success: false,
    error: null,
  },
  resettingPasswordUrl: {
    generating: false,
    success: false,
    url: null,
    error: null,
  },
  deleteUser: {
    deleting: false,
    success: false,
    error: null,
  },
  logoutUser: false,
  logoutUserSuccess: false,
  logoutUserError: null,
  updatePermissions: {
    updating: false,
    success: false,
    error: null,
  },
};

function usersReducer(state = initState, action) {
  switch (action.type) {
    case CREATING_USER_REQUEST:
      return Object.assign({}, state, {
        ...state,
        creatingUser: { creating: true },
      });
    case CREATING_USER_REQUEST_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        user: action.payload,
        creatingUser: { creating: false, success: true, error: null },
      });
    case CREATING_USER_REQUEST_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unkown error";

      return Object.assign({}, state, {
        ...state,
        creatingUser: {
          creating: false,
          success: false,
          error: error,
        },
      });
    }

    case FETCHING_USER:
      return Object.assign({}, state, {
        ...state,
        user: null,
        fetchingUser: { fetching: true },
      });
    case FETCHING_USER_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        user: action.payload,
        fetchingUser: { fetching: false, error: null },
      });
    case FETCHING_USER_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unkown error";

      return Object.assign({}, state, {
        ...state,
        fetchingUser: {
          fetching: false,
          error: error,
        },
      });
    }
    case FETCHING_USERS:
      const { page, filters } = action.payload;

      if (page === 0) {
        return Object.assign({}, state, {
          ...state,
          loading: filters.refresh ? true : state.loading,
          items: filters.refresh ? [] : state.items,
          pagination: {
            currentPage: -1,
            totalPages: 1,
            recordsPerPage: 20,
            totalRecordsCount: filters.refresh
              ? 0
              : state.pagination.totalRecordsCount,
          },
        });
      }

      return Object.assign({}, state, { ...state, loading: true });
    case FETCHING_USERS_SUCCEEDED:
      var items = state.items;
      var {
        currentPage,
        totalPages,
        recordsPerPage,
        totalRecordsCount,
        records = [],
      } = action.payload;

      if (currentPage !== 0) {
        items = [...state.items, ...records];
      } else {
        items = records;
      }

      /** 
      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id === y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);
      */

      return Object.assign({}, state, {
        ...state,
        loading: false,
        items: items,
        pagination: {
          ...state.pagination,
          currentPage,
          totalPages,
          recordsPerPage,
          totalRecordsCount,
        },
      });
    case FETCHING_USERS_FAILED:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 1,
          recordsPerPage: 20,
          totalRecordsCount: 0,
        },
      });

    case FETCHING_USERS_COUNT:
      console.log("user: ", state.count);
      return Object.assign({}, state, {
        ...state,
        count: { ...state.count, all: { fetching: true, total: 0 } },
      });

    case FETCHING_USERS_COUNT_SUCCEEDED:
      console.log("user success: ", state.count);
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          all: { fetching: false, total: action.payload },
        },
      });
    case FETCHING_USERS_COUNT_FAILED: {
      let error = action.payload
        ? action.payload.errors && action.payload.errors[0].message
        : null;

      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          all: { fetching: false, total: 0, error: error },
        },
      });
    }

    case FETCHING_ACTIVE_USERS_COUNT:
      console.log("active: ", state.count);
      return Object.assign({}, state, {
        ...state,
        count: { ...state.count, active: { fetching: true, total: 0 } },
      });
    case FETCHING_ACTIVE_USERS_COUNT_SUCCEEDED:
      console.log("active success: ", state.count);
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          active: { fetching: false, total: action.payload },
        },
      });
    case FETCHING_ACTIVE_USERS_COUNT_FAILED: {
      let error = action.payload
        ? action.payload.errors && action.payload.errors[0].message
        : null;

      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          active: { fetching: false, total: 0, error: error },
        },
      });
    }

    case FETCHING_DEACTIVATED_USERS_COUNT: {
      return Object.assign({}, state, {
        ...state,
        count: { ...state.count, deactivated: { fetching: true, total: 0 } },
      });
    }

    case FETCHING_DEACTIVATED_USERS_COUNT_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          deactivated: { fetching: false, total: action.payload, error: null },
        },
      });
    }

    case FETCHING_DEACTIVATED_USERS_COUNT_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;

      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          deactivated: { fetching: false, total: 0, error: error },
        },
      });
    }

    case FETCHING_DAU_COUNT: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          dau: { fetching: true, total: 0 },
        },
      });
    }

    case FETCHING_DAU_COUNT_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          dau: { fetching: false, total: action.payload },
        },
      });
    }

    case FETCHING_DAU_COUNT_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;

      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          dau: { fetching: false, total: 0, error: error },
        },
      });
    }

    case FETCHING_WAU_COUNT: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          wau: { fetching: true, total: 0 },
        },
      });
    }

    case FETCHING_WAU_COUNT_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          wau: { fetching: false, total: action.payload },
        },
      });
    }

    case FETCHING_WAU_COUNT_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;

      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          wau: { fetching: false, total: 0, error: error },
        },
      });
    }

    case FETCHING_MAU_COUNT: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          mau: { fetching: true, total: 0 },
        },
      });
    }

    case FETCHING_MAU_COUNT_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          mau: { fetching: false, total: action.payload },
        },
      });
    }

    case FETCHING_MAU_COUNT_FAILED: {
      let error =
        action.payload && action.payload.message
          ? action.payload.message[0].message
          : null;

      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          mau: { fetching: false, total: 0, error: error },
        },
      });
    }

    case FETCHING_NEW_USERS_COUNT: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          new: { fetching: true, total: 0 },
        },
      });
    }

    case FETCHING_NEW_USERS_COUNT_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          new: { fetching: false, total: action.payload },
        },
      });
    }

    case FETCHING_NEW_USERS_COUNT_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;

      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          new: { fetching: true, total: 0, error: error },
        },
      });
    }

    case UPDATING_USER_REQUEST:
      return Object.assign({}, state, {
        ...state,
        updatingUser: { updating: true },
      });
    case UPDATING_USER_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        user: action.payload,
        updatingUser: { updating: false, success: true, error: null },
      });
    case UPDATING_USER_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unkown error";

      return Object.assign({}, state, {
        ...state,
        updatingUser: {
          updating: false,
          success: false,
          error: error,
        },
      });
    }

    case UPDATING_USER_PERMISSIONS:
      return Object.assign({}, state, {
        ...state,
        updatePermissions: {
          updating: true,
        },
      });
    case UPDATING_USER_PERMISSIONS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        user: action.payload,
        updatePermissions: { updating: false, success: true, error: null },
      });
    case UPDATING_USER_PERMISSIONS_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        updatePermissions: {
          updating: false,
          success: false,
          error: error,
        },
      });
    }

    case ACTIVATING_USER_REQUEST:
      return Object.assign({}, state, {
        ...state,
        activatingUser: { activating: true },
      });
    case ACTIVATING_USER_SUCCEEDED:
      let type = action.payload.type;
      let updated = action.payload.response;

      let newtems = [];
      if (type) {
        let includeUpdated = true;
        if (
          (type === "active" && !updated.enabled) ||
          (type === "disabled" && updated.enabled)
        ) {
          includeUpdated = false;
        }

        if (includeUpdated) {
          newtems = state.items.map((item) =>
            item.id === updated.id ? updated : item
          );
        } else {
          newtems = state.items.filter((item) => item.id !== updated.id);
        }
      } else {
        newtems = state.items;
      }

      return Object.assign({}, state, {
        ...state,
        items: newtems,
        user: updated,
        activatingUser: { activating: false, success: true, error: null },
      });
    case ACTIVATING_USER_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unkown error";

      return Object.assign({}, state, {
        ...state,
        activatingUser: {
          activating: false,
          success: false,
          error: error,
        },
      });
    }

    case RESET_PASSWORD:
      return Object.assign({}, state, {
        ...state,
        resettingPassword: { resetting: true },
      });
    case RESET_PASSWORD_SUCCEEDED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unkown error";

      return Object.assign({}, state, {
        ...state,
        resettingPassword: { resetting: false, success: true, error: error },
      });
    }
    case RESET_PASSWORD_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unkown error";

      return Object.assign({}, state, {
        ...state,
        resettingPassword: {
          resetting: false,
          success: false,
          error: error,
        },
      });
    }

    case RESET_PASSWORD_REQUEST:
      return Object.assign({}, state, {
        ...state,
        resettingPasswordRequest: { requesting: true },
      });
    case RESET_PASSWORD_REQUEST_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        resettingPasswordRequest: {
          requesting: false,
          success: true,
          error: null,
        },
      });
    case RESET_PASSWORD_REQUEST_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unkown error";

      return Object.assign({}, state, {
        ...state,
        resettingPasswordRequest: {
          requesting: false,
          success: false,
          error: error,
        },
      });
    }
    case RESET_PASSWORD_LINK:
      return Object.assign({}, state, {
        ...state,
        resettingPasswordUrl: { generating: true },
      });
    case RESET_PASSWORD_LINK_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        resettingPasswordUrl: {
          generating: false,
          success: true,
          url: action.payload,
          error: null,
        },
      });
    case RESET_PASSWORD_LINK_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unkown error";

      return Object.assign({}, state, {
        ...state,
        resettingPasswordUrl: {
          generating: false,
          success: false,
          error: error,
        },
      });
    }
    case DELETING_USER_REQUEST:
      return Object.assign({}, state, {
        ...state,
        deleteUser: { deleting: true },
      });
    case DELETING_USER_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        deleteUser: { deleting: false, success: true, error: null },
      });
    case DELETING_USER_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unkown error";

      return Object.assign({}, state, {
        ...state,
        deleteUser: {
          deleting: false,
          success: false,
          error: error,
        },
      });
    }

    case FETCHING_COGNITO_USER_PROFILE:
      return Object.assign({}, state, {
        ...state,
      });
    case FETCHING_COGNITO_USER_PROFILE_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        me: action.payload,
      });
    case FETCHING_COGNITO_USER_PROFILE_FAILED:
      return Object.assign({}, state, {
        ...state,
      });
    
    case FETCHING_COLLECTIONS:
      const requestPage = action.payload.page;
      const requestFilters = action.payload.filters;
      if (requestPage === 0){
      return Object.assign({}, state, {
        ...state,
        collections: {
          loading : true,
          pagination: {
            currentPage: -1,
            totalPages: 1,
            recordsPerPage: 20,
            totalRecordsCount: requestFilters.refresh
              ? 0
              : state.pagination.totalRecordsCount,
          },
        }
      });
    }
    case FETCHING_COLLECTIONS_SUCCEEDED:
      var items = state.collections.items;

            var {
                currentPage,
                totalPages,
                recordsPerPage,
                totalRecordsCount,
                records = [],
            } = action.payload;

            if (currentPage !== 0) {
                items = [...state.collections.items, ...records];
            } else {
                items = records;
            }
      console.log("item",items)
      return Object.assign({}, state, {
        ...state,
        loading: false,
        collections: {
          loading:false,
          items: items,
          pagination: {
            ...state.pagination,
            currentPage,
            totalPages,
            recordsPerPage,
            totalRecordsCount,
        },
        }

      });
    case FETCHING_COLLECTIONS_FAILED:
      let error = action.payload
      ? action.payload.errors && action.payload.errors[0].message
      : null;

      return Object.assign({}, state, {
        ...state,
        collections:{
          loading: false,
          error,
          pagination: {
            currentPage: -1,
            totalPages: 1,
            recordsPerPage: 20,
            totalRecordsCount: 0,
        },
        }
      });
    default:
      return state;
  }
}

export { usersReducer };
